import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ApiService } from 'app/services/api.service';
import { CustomerRule } from 'app/models/customer-rule';
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: 'app-customer-rules',
    imports: [TranslateModule, MatIconModule],
    templateUrl: './customer-rules.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./customer-rules.component.css']
})
export class CustomerRulesComponent implements OnChanges {
  @Input() customerId: string;
  @Input() serverId: string;

  rules: CustomerRule[] = [];
  loading = false;

  constructor(private api: ApiService) {}
  ngOnChanges(): void {
    this.fetchRules();
  }

  private fetchRules(): void {
    if (!this.customerId || !this.serverId) return;

    this.loading = true;

    const serverId = this.serverId.substring(0, 8);
    const customerId = this.customerId.substring(8);
    this.api.getCompanyRules(customerId, serverId)
      .subscribe({
        next: (data: CustomerRule[]) => {
          this.rules = data;
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load customer rules:', err);
          this.loading = false;
        }
      });
  }
}